import styles from '../../styles/plan/relatedArticle.scss';
import cx from 'classnames';

interface Article {
  link: string;
  title: string;
  subtitle: string;
}

interface Props {
  article: Article;
}

const RelatedArticle = ({ article }: Props) => (
  <a href={article.link} className={cx(styles['article-card'], 'inline-block')}>
    <p className="font--bold text--xmd font--dark-grey">{article.title}</p>
    <p className="text--md font--grey mt10">{article.subtitle}</p>
    <span className="mt10 inline-block">Read More</span>
  </a>
);

export default RelatedArticle;



// WEBPACK FOOTER //
// ./components/plan/relatedArticle.tsx